// @flow

import { last } from 'lodash';
import type { SelectedNode } from 'app/get-help/utils/tree/types';

export const handleCampaign = (nodes: SelectedNode[]) => {
  const questionNodes = nodes.filter(node => node.id !== 'help');
  const lastQuestionNode = last(questionNodes);
  const lastQuestionNodeExport = lastQuestionNode.export();

  if (!lastQuestionNodeExport || !window.adaEmbed) {
    // Should we track the fact that Ada wasn't initialized? (only for qualified users)
    return;
  }

  // Convert `formatted` (which is the 'label' of a node, essentially the selection text) to
  // a String and then to snake case to match Ada's campaign key.
  // Wrapped in a try-catch because `formatted` is of "mixed" type which could potentially return
  // an object or something else that cannot be cast to a String.
  let formattedCampaignKey = '';
  try {
    formattedCampaignKey = String(lastQuestionNodeExport.formatted).replace(
      / /g,
      '_'
    );
  } catch (e) {
    // TODO: track this error to understand where formatted might not be able to be cast to a String
  }

  try {
    // Campaigns are managed here: https://zapier.ada.support/answers/campaigns
    window.adaEmbed.triggerCampaign(formattedCampaignKey);
  } catch (e) {
    // Most likely will error if the campaignKey doesn't match any campaigns set up in Ada:
    //    ReferenceError: campaignKey is not defined
    // TODO: Track in Grafana so we can see when campaigns are not triggered
  }
};
